<template>

    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pb-3">
                        <CCol sm="12">
                            <CButton
                                v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  
                                color="primary" @click="create">Создать</CButton>
                        </CCol>
                    </CRow>                    
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Название</th>
                                <th>Вес</th>
                                <th>Стоимость</th>
                                <th class="desktop-only">Активен</th>
                                <th></th>
                            </thead>
                            <draggable v-model="ingredients" tag="tbody">
                                <tr v-for="ingredient in ingredients" :key="ingredient.id">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ ingredient.title }}</td>
                                    <td>{{ ingredient.weight }}</td>
                                    <td>{{ ingredient.price }}</td>
                                    <td class="desktop-only">
                                        <CBadge :color="getBadge(ingredient.enabled)">
                                            &nbsp;{{ ingredient.enabled ? 'Да' : 'Нет' }}&nbsp;
                                        </CBadge>
                                    </td>
                                    <td>
                                        <CButton @click="edit(ingredient.id)"><CIcon :content="$options.icons.cilPencil" class="handle" /></CButton>
                                        <CButton
                                            v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  
                                            @click="removeConfirmation(ingredient.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="createEditModalTitle"
            :show.sync="createEditModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Название</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.ingredient.title"
                                    placeholder="Название ингредиента"
                                    description="Обязательно для заполнения"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Вес</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.ingredient.weight"
                                    placeholder="Вес ингридиента"
                                    description="Необязательно для заполнения"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Стоимость</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.ingredient.price"
                                    placeholder="Стоимость ингредиента"
                                    description="Введите 0, если не влияет на стоимость блюда"
                                />
                            </CCol>




                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Калории</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.ingredient.calories"
                                    placeholder="Калории"
                                    description="Введите 0, если не влияет на калории"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Белки</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.ingredient.protein"
                                    placeholder="Белки"
                                    description="Введите 0, если не влияет на белок"
                                    step="0.1"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Жиры</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.ingredient.fat"
                                    placeholder="Жиры"
                                    description="Введите 0, если не влияет на жиры"
                                    step="0.1"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Углеводы</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.ingredient.carbohydrates"
                                    placeholder="Углеводы"
                                    description="Введите 0, если не влияет на углеводы"
                                    step="0.1"
                                />
                            </CCol>





                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="createEditModal.ingredient.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div
                    slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createEditModal.visible = false">Отмена</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createUpdateIngredient">{{ createEditModalButton }}</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить ингредиент? Это действие нельзя будет отменить.</p>
                </div>
                <div
                    v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  
                    slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal.visible = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="remove">Удалить</CButton>
                </div>
            </template>
        </CModal>


    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';

    export default {

        name: 'RestaurantIngredients',
  
        components: {
            RestaurantsTabLinks,
            draggable,
        },
  
        data () {
            return {
                restaurant: {},
                ingredients: [],
                createEditModal: {
                    visible: false,
                    editMode: false,
                    editId:0,
                    ingredient: {
                        title: '',
                        weight: 0,
                        price: 0,
                        enabled: false,
                        position: 0,

                        carbohydrates: 0,
                        protein: 0,
                        fat: 0,
                        calories: 0,
                    }
                },
                deleteModal: {
                    visible: false,
                    ingredientId: 0
                }
            }
        },
    
        computed: {
            createEditModalTitle: function() {
                return this.createEditModal.editMode ? 'Редактирование ингредиента' : 'Создание ингредиента';
            },
            createEditModalButton: function() {
                return this.createEditModal.editMode ? 'Сохранить' : 'Создать';
            },
            
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios.get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + id + '/ingredients')
                .then(resp => {
                    this.ingredients = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil
        },

        methods: {
            formatMacro(value) {
                const n = Number(value);
                if (!Number.isFinite(n)) return '0.0';
                return (Math.round((n + Number.EPSILON) * 10) / 10).toFixed(1);
            },

            create() {
                this.createEditModal.editMode = false;
                this.createEditModal.ingredient.title = '',
                this.createEditModal.ingredient.weight = null;
                this.createEditModal.ingredient.price = 0;

                this.createEditModal.ingredient.calories = 0;
                this.createEditModal.ingredient.protein = this.formatMacro(0);
                this.createEditModal.ingredient.fat = this.formatMacro(0);
                this.createEditModal.ingredient.carbohydrates = this.formatMacro(0);

                this.createEditModal.ingredient.enabled = true;
                this.createEditModal.visible = true;
            },

            createUpdateIngredient() {
            
                if(!this.createEditModal.ingredient.title) {
                    this.$root.$emit('showError', 'Название ингредиента является обязательным.');
                    return;
                }
                if(this.createEditModal.ingredient.price === null) {
                    this.$root.$emit('showError', 'Стоимость является обязательной для заполнения.');
                    return;
                }
                if(!this.createEditModal.ingredient.weight) {
                    this.createEditModal.ingredient.weight = 0;
                }

                if(this.createEditModal.editMode) {
                    Vue.axios.post('/restaurants/' + this.restaurant.id + '/ingredients/update/' + this.createEditModal.editId , this.createEditModal.ingredient)
                        .then(resp => {
                            const justUpdated = resp.data;
                            const _ingredients = this.ingredients.slice();
                            for(var i = 0; i < _ingredients.length; i++) {
                                if(_ingredients[i].id === justUpdated.id) {
                                    _ingredients[i] = justUpdated;
                                }
                            }
                            this.ingredients = _ingredients;
                            this.createEditModal.visible = false;
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                } else {
                    Vue.axios.post('/restaurants/' + this.restaurant.id + '/ingredients/create', this.createEditModal.ingredient)
                        .then(resp => {
                            const justCreated = resp.data;
                            const _ingredients = this.ingredients.slice();
                            _ingredients.push(justCreated);
                            this.ingredients = _ingredients;
                            this.createEditModal.visible = false;
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                }
            },

            edit(id) {
                this.createEditModal.editId = id;
                this.createEditModal.editMode = true;
            
                var _ingredient = {};
                for(var i = 0; i < this.ingredients.length; i++) {
                    if(this.ingredients[i].id === id) {
                        _ingredient = this.ingredients[i];
                    }
                }

                this.createEditModal.ingredient.title = _ingredient.title,
                this.createEditModal.ingredient.weight = _ingredient.weight;
                this.createEditModal.ingredient.price = _ingredient.price;
                this.createEditModal.ingredient.enabled = _ingredient.enabled;
                this.createEditModal.ingredient.position = _ingredient.position;

                this.createEditModal.ingredient.calories = +_ingredient.calories;
                this.createEditModal.ingredient.protein = this.formatMacro(_ingredient.protein);
                this.createEditModal.ingredient.fat = this.formatMacro(_ingredient.fat);
                this.createEditModal.ingredient.carbohydrates = this.formatMacro(_ingredient.carbohydrates);
            
                this.createEditModal.visible = true;
            },

            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.ingredients.forEach(ingredient => {
                    reorder.push({
                        id: ingredient.id,
                        position: ++index
                    });
                });
                Vue.axios.post('/restaurants/' + this.restaurant.id + '/ingredients/reorder', { reorder: reorder })
                    .then(resp => {
                        this.$router.push('/restaurants/' + this.restaurant.id)
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            removeConfirmation(id) {
                this.deleteModal.ingredientId = id;
                this.deleteModal.visible = true;
            },

            remove() {
                const id = this.deleteModal.ingredientId;
                Vue.axios.delete('/restaurants/' + this.restaurant.id + '/ingredients/' + id)
                    .then(resp => {
                        const _ingredients = []; 
                        for(var i = 0; i < this.ingredients.length; i++) {
                            if(id != this.ingredients[i].id) {
                                _ingredients.push(this.ingredients[i]);
                            }
                        }
                        this.ingredients = _ingredients;
                        this.deleteModal.visible = false;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({ path: '/restaurants/' + this.$route.params.id })
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}

@media (max-width: 767px) {
    .desktop-only {
        display: none;
    }
}
</style>
